import { AbstractHook } from '@hooks/abstraction';
import { TagService } from '../services/tag.service';
import { TagResponse } from '../services/responses/tag.response';

export class TagHook extends AbstractHook<TagResponse, TagService> {}
